import { render, staticRenderFns } from "./PageShoplist.vue?vue&type=template&id=a817c6a8&"
import script from "./PageShoplist.vue?vue&type=script&lang=js&"
export * from "./PageShoplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a817c6a8')) {
      api.createRecord('a817c6a8', component.options)
    } else {
      api.reload('a817c6a8', component.options)
    }
    module.hot.accept("./PageShoplist.vue?vue&type=template&id=a817c6a8&", function () {
      api.rerender('a817c6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageShoplist.vue"
export default component.exports